import {
  LearnerProfile,
  LearnerProfileRepository,
} from '@/domain/precon-supporter';

/**
 * ニックネーム設定ユースケース
 *
 * 修了証に表示するニックネームを設定する。
 * 一度設定すると変更できない（不正防止のため）。
 */
export class SetNicknameUseCase {
  constructor(private readonly repository: LearnerProfileRepository) {}

  /**
   * ニックネームを設定
   * @param nickname - 設定するニックネーム
   * @throws Error - 既にニックネームが設定されている場合、または空の場合
   */
  async execute(nickname: string): Promise<void> {
    let profile = await this.repository.find();
    if (!profile) {
      profile = LearnerProfile.create();
    }

    // ドメインロジックで検証・設定（既に設定済みの場合はエラーがスローされる）
    const updated = profile.setNickname(nickname);
    await this.repository.save(updated);
  }
}
